import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NotFound() {
  useEffect(() => { document.title = "Lost in the garden — 404"; }, []);
  return (
    <div className="grain min-h-screen bg-[#F7F1E1] grid place-items-center px-6">
      <div className="text-center max-w-lg">
        <motion.svg width="140" height="140" viewBox="0 0 140 140" className="mx-auto mb-8" aria-hidden="true"
          initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }}>
          <motion.path d="M70 130 C70 90 40 80 70 40 C100 80 70 90 70 130" fill="none" stroke="#81754B" strokeWidth="2"
            initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 1.5 }} />
          <motion.circle cx="70" cy="30" r="12" fill="#66371B" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.2 }} />
          <motion.path d="M50 60 Q70 50 90 60" fill="none" stroke="#B4833D" strokeWidth="2"
            initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 1, delay: 0.5 }} />
        </motion.svg>
        <p className="font-serif text-7xl text-[#3F3F2C]">404</p>
        <p className="signature text-2xl text-[#81754B] mt-3">This page wandered off the path.</p>
        <p className="text-[#3F3F2C] mt-4">The page you&apos;re looking for isn&apos;t here — but there&apos;s plenty growing elsewhere.</p>
        <Link to="/" data-testid="notfound-home-link"
          className="mt-8 inline-block rounded-full bg-[#3F3F2C] px-8 py-4 text-[#F7F1E1] hover:bg-[#66371B] transition-colors">
          Back to the studio
        </Link>
      </div>
    </div>
  );
}
